// 重置浏览器样式
import boot from '$boot/boot';
import '$common/style/reset.styl';
import pageComponent from './main';
import DocumentMixin from '$common/utils/vue-plugin/mixins/document-mixin';
import DocumentTitlePlugin from '$common/utils/vue-plugin/document-title';
import ToolMixin from '$common/utils/vue-plugin/mixins/tool-mixin';
import TecalcMixin from '$common/utils/vue-plugin/mixins/recalc-mixin';
import goAppMixin from '$common/utils/vue-plugin/mixins/goApp-mixin/goApp-mixin.js';

import store from './store';
import Vue from 'vue';
import i18n from './i18n';
Vue.use(DocumentTitlePlugin)
try {
  //  将后端渲染的东西序列化成对象
  window.ssrConfig = JSON.parse(decodeURIComponent(window.ssrConfig));
} catch (err) {}

Vue.use(DocumentTitlePlugin)
boot({
  Vue,
  pageComponent,
  before: config => Object.assign({}, config, {
    mixins: [ToolMixin, TecalcMixin, DocumentMixin, store,goAppMixin],
    i18n: i18n.use(Vue)
  })
});